import styled from 'styled-components';

const ButtonStyle = styled.div`
	--btnPadTB: var(--sp2x);
	--btnPadLR: var(--sp3x);
	--btnBorderRadius: var(--sp5x);

	/* //! Instagram Size  */
	/* --buttonInstTB: var(--sp1-5x);
	--buttonInstLR: var(--sp2x);
	--borderRadiusInst: var(--sp3x); */

	/* //! Category */
	--buttonTB: var(--sp2x);
	--buttonLR: var(--sp4x);

	/* //! Full */
	--btnFullPadTB: var(--sp2-5x);
	--btnFullPadLR: var(--sp4x);
	--btnFullBorderRadius: var(--sp1x);

	&.btn {
		width: fit-content;
		overflow: hidden;
		cursor: pointer;

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--btnPadTB) var(--btnPadLR);
			color: var(--pink1000);
			font-size: var(--p4);
			font-family: var(--montserrat_arm);
			font-weight: 500;
			background-color: var(--mainColor);
			border-radius: var(--btnBorderRadius);
			transition:
				color var(--trTime) ease-out,
				background-color var(--trTime) ease-out,
				border-color var(--trTime) ease-out;
			cursor: pointer;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						color: var(--mainColor);
						background-color: var(--pink1000);
					}
				}
			}

			&:active {
				background-color: var(--pink1100);
			}
		}

		&.category {
			a,
			button {
				color: var(--mainColor);
				background-color: var(--neutral1000);
				border: 1px solid var(--neutral600);

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							border: 1px solid var(--mainColor);
						}
					}
				}
			}

			&.active {
				pointer-events: none;
				cursor: default;
				a,
				button {
					color: var(--neutral1000);
					background-color: var(--mainColor);
					border: 1px solid var(--mainColor);
				}
			}
		}

		&.tag {
			a,
			button {
				--btnPadTB: var(--buttonTB);
				--btnPadLR: var(--buttonLR);
			}
		}

		&.full {
			width: 100%;

			a,
			button {
				--btnPadTB: var(--btnFullPadTB);
				--btnPadLR: var(--btnFullPadLR);
				--btnBorderRadius: var(--btnFullBorderRadius);

				width: 100%;
				color: var(--mainColor);
				background-color: var(--neutral1000);
				border: 1px solid var(--neutral1000);

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--neutral1000);
							background-color: var(--mainColor);
						}
					}
				}
			}
		}

		&.reverse {
			a,
			button {
				color: var(--mainColor);
				background-color: var(--neutral1000);
				border: unset;
				border-radius: 100px;
				transition:
					color var(--trTime) ease-out,
					background-color var(--trTime) ease-out,
					border-color var(--trTime) ease-out,
					opacity var(--trTime) ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--mainColor);
							background-color: var(--pink1000);
						}
					}
				}

				&:active {
					background-color: var(--pink1100);
				}
			}

			&.disabled {
				a,
				button {
					&:hover {
						background-color: var(--neutral1000);
					}
				}
			}
		}

		&.text-link {
			a,
			button {
				padding: 0;
				color: var(--neutral1000);
				background: transparent;
				border: none;
				border-radius: 0;
				text-decoration: underline;
				text-underline-offset: 3px;
				transition:
					color var(--trTime) ease-out,
					background-color var(--trTime) ease-out,
					opacity var(--trTime) ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--pink1000);
							background: transparent;
						}
					}
				}

				&:active {
					color: var(--pink1100);
					background: transparent;
				}
			}
		}

		&.instagram {
			a,
			button {
				--btnPadTB: var(--buttonInstTB);
				--btnPadLR: var(--buttonInstLR);
				--btnBorderRadius: var(--borderRadiusInst);

				color: var(--neutral1000);
				background-color: var(--mainColor);
				border: unset;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--mainColor);
							background-color: var(--neutral1000);
						}
					}
				}
			}
		}

		&.disabled {
			pointer-events: none;

			a,
			button {
				opacity: 0.5;
				pointer-events: none;
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--btnBorderRadius: var(--sp4x);

		/* //! Instagram Size  */
		/* --buttonInstTB: var(--sp1x); */

		/* //! Category */
		--buttonLR: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--btnPadTB: var(--sp1-5x);
		--btnPadLR: var(--sp2-5x);
		--btnBorderRadius: var(--sp5x);

		/* //! Instagram Size  */
		/* --borderRadiusInst: var(--sp2-5x); */

		/* //! Category */
		--buttonTB: var(--sp1-5x);

		/* //! Full */
		--btnFullPadTB: 18px;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--btnPadLR: var(--sp3x);

		/* //! Instagram Size  */
		/* --borderRadiusInst: var(--sp2x); */

		/* //! Category */
		--buttonLR: var(--sp3-5x);

		/* //! Full */
		--btnFullPadTB: var(--sp2x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--btnPadTB: var(--sp2x);

		/* //! Category */
		--buttonLR: calc(var(--sp2x));
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--btnPadTB: var(--sp1-5x);
		--btnPadLR: var(--sp3x);

		/* //! Instagram Size  */
		/* --buttonInstTB: var(--sp1x);
		--buttonInstLR: var(--sp1-5x); */

		/* //! Category */
		--buttonTB: var(--sp1x);
		--buttonLR: var(--sp1-5x);

		/* //! Full */
		--btnFullPadTB: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
